const STORAGE_KEY = 'fattah.sampleData.enabled';

export function isSampleDataEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setSampleDataEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

export const SAMPLE_DATA_GUIDES = [
  { label: 'POS setup wizard', path: '/onboarding/pos', modules: ['POS'] as const },
  { label: 'CRM tour', path: '/crm', modules: ['CRM'] as const },
  { label: 'HR tour', path: '/hr', modules: ['HR'] as const },
  { label: 'Social demo workflow', path: '/social', modules: ['SOCIAL'] as const },
] as const;
